export default "/staticreactui/static/media/static/media/not-found.b29b1e98.webp";